<template>
    <div class="mx-auto header-margin">
        <div class="text-center p-2">
            <h3 class="text-primary mb-2 text-nowrap">{{ $t('deactivate.complete.title') }}</h3>
            <p class="mb-3 ">{{ $t('deactivate.complete.text') }}</p>
            <div class="text-center mt-5">
                <button type="submit" class="btn btn-primary"  @click="handleOnSubmit">{{ $t('deactivate.complete.returnTop') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        handleOnSubmit() {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.btn {
    width: 160px;
}
</style>
